import { FunctionComponent } from "react";

import ProfileForm from "./profileForm"; 

const Profile: FunctionComponent = () => {
  return <ProfileForm />;
};

export default Profile;